import React, { useState, useEffect } from 'react'
import avenirplus from '../asset/images/avenirplus.png'
import {H1a} from '../common/H1/H1'

function Header() {
	const [isHeaderActive, setHeaderActive] = useState(true)
	const toggleElem = function (elem) {
		elem.classList.toggle('active')
	}

	useEffect(() => {
		const handleScroll = () => {
			const scrollPosition = window.scrollY
			if (scrollPosition === 0) {
				setHeaderActive(true)
			} else {
				setHeaderActive(false)
			}
		}

		const navTogglers = document.querySelectorAll('[data-nav-toggler]')
		const searchTogglers = document.querySelectorAll('[data-search-toggler]')
		const whishlistBtns = document.querySelectorAll('[data-whish-btn]')
		const navbar = document.querySelector('[data-navbar]')
		const overlay = document.querySelector('[data-overlay]')
		const searchBox = document.querySelector('[data-search-box]')

		const toggleNavbar = () => {
			toggleElem(navbar)
			toggleElem(overlay)
		}

		const toggleSearchBox = () => {
			toggleElem(searchBox)
		}

		const toggleWishlist = (event) => {
			toggleElem(event.target)
		}

		for (let i = 0; i < navTogglers.length; i++) {
			navTogglers[i].addEventListener('click', toggleNavbar)
		}

		for (let i = 0; i < searchTogglers.length; i++) {
			searchTogglers[i].addEventListener('click', toggleSearchBox)
		}

		for (let i = 0; i < whishlistBtns.length; i++) {
			whishlistBtns[i].addEventListener('click', toggleWishlist)
		}

		// Attach scroll event listener
		window.addEventListener('scroll', handleScroll)
		// Clean up event listeners when component unmounts
		return () => {
			for (let i = 0; i < navTogglers.length; i++) {
				navTogglers[i].removeEventListener('click', toggleNavbar)
			}

			for (let i = 0; i < searchTogglers.length; i++) {
				searchTogglers[i].removeEventListener('click', toggleSearchBox)
			}

			for (let i = 0; i < whishlistBtns.length; i++) {
				whishlistBtns[i].removeEventListener('click', toggleWishlist)
			}

			// Remove scroll event listener on unmount
			window.removeEventListener('scroll', handleScroll)
		}
	}, []) // Empty dependency array ensures useEffect runs only once after the initial render

	return (
		<header className={`header ${isHeaderActive ? '' : 'active'}`} data-header>
			<div className="container">
					<H1a>
					<a href="#home" className="logo">Avenir +
					</a>
					</H1a>

				<nav className="navbar" data-navbar>
					<div className="navbar-top">
						<a href="#home">
            <img src={avenirplus} alt="logo" style={{width:"15%"}}/>
						</a>

						<button className="nav-close-btn" data-nav-toggler>
							<ion-icon name="close-outline"></ion-icon>
						</button>
					</div>
					<ul className="navbar-list">
						<li className="navbar-item">
							<a href="#home" className="navbar-link" data-nav-toggler>
								ACCUEIL
							</a>
						</li>
						<li className="navbar-item">
							<a href="#about" className="navbar-link" data-nav-toggler>
								CONCEPT
							</a>
						</li>
						<li className="navbar-item">
							<a href="#courses" className="navbar-link" data-nav-toggler>
								COURS
							</a>
						</li>
{/* 
						<li className="navbar-item">
							<a href="#planning" className="navbar-link" data-nav-toggler>
								PLANNING
							</a>
						</li> */}

						<li className="navbar-item">
							<a href="#tarifs" className="navbar-link" data-nav-toggler>
								TARIFS
							</a>
						</li>
						<li className="navbar-item">
							<a href="#contact" className="navbar-link" data-nav-toggler>
								CONTACT
							</a>
						</li>
					</ul>
				</nav>
				<div className="header-actions">

					<div className="contact-btn">
						<em style={{display:"flex", fontSize:"1.4rem"}}>
							<ion-icon name="call" aria-hidden="true"></ion-icon>06 14 17 01 45
						</em>
						<em style={{display:"flex", fontSize:"1.4rem"}}>
							<ion-icon name="mail-outline" aria-hidden="true"></ion-icon>coursavenirplus@hotmail.com
						</em>
						<em style={{display:"flex", fontSize:"1.4rem"}}>
							<ion-icon name="location-outline" aria-hidden="true"></ion-icon>12 rue du Petit Parc 77150 LESIGNY
						</em>
					</div> 

					<button className="header-action-btn nav-open-btn" data-nav-toggler>
						<ion-icon name="menu-outline"></ion-icon>
					</button>
				</div>


				<div className="overlay" data-nav-toggler data-overlay></div>
			</div>
		</header>
	)
}

export default Header
